import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectStripeMutation } from "../graphql/mutations";
import type {
  ConnectStripeMutationType,
  ConnectStripeMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectStripeMutation = (
  options?: MutationHookOptions<
    ConnectStripeMutationType,
    ConnectStripeMutationVariablesType
  >
) => {
  return useMutation<
    ConnectStripeMutationType,
    ConnectStripeMutationVariablesType
  >(ConnectStripeMutation, options);
};
